import React, { useState, useEffect } from "react";
import { SelectProps } from "@material-ui/core";
import StatesSelector from "../presentation/StatesSelector";
import { State, IGeoDatabase } from "@idha/idha-utils";
import { geoDBService } from "../../../services/geoDBService";
interface StateSelectorControllerProps extends SelectProps {
    country?: string;
    helperText?: string;
}
const StateSelectorContainer: React.FC<StateSelectorControllerProps> = ({
    country,
    helperText,
    ...rest
}) => {
    const [statesList, setStatesList] = useState<State[] | undefined>();

    async function findStates(): Promise<void> {
        if (!country) {
            setStatesList([]);
            return;
        }
        const states = await geoDBService.listStates(country, "NAME");
        states.sort((state1: State, state2: State) => {
            return state1.name.localeCompare(state2.name);
        });
        setStatesList(states);
    }

    useEffect(() => {
        async function fetchStatesList() {
            if (!statesList) {
                await findStates();
            }
        }
        fetchStatesList();
    }, [country]);

    return (
        <StatesSelector
            {...rest}
            stateList={statesList}
            helperText={helperText}
        />
    );
};

export default StateSelectorContainer;
